import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from 'vue';

// icons
import { add, close, arrowBack, } from 'ionicons/icons';

// components
import { IonPage, IonHeader, IonTitle, IonButtons, IonButton, IonIcon, IonToolbar,
        IonSegment, IonSegmentButton, IonContent, IonGrid, loadingController, } from '@ionic/vue';
import RolesInClassesModal from '@/components/teacher/RolesInClassesModal.vue';
import RoleInSchoolSelectModal from '@/components/teacher/RoleInSchoolSelectModal.vue';
import UserProfileFormModal from '@/components/modals/UserProfileFormModal.vue';

// utils
import config from '@/config';
import { useStore } from '@/store';
import { utils } from '@/composables/utils';
import { useRoute, useRouter } from 'vue-router';

// services
import AuthService from '@/services/AuthService';
import { customTokenSignin } from '@/auth';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'TeacherRolesModal',
  props: ['isPage'],
  setup(__props) {

// vue
const props = __props;

const selectedSection = ref("school");
const { closeModal } = utils();
const router = useRouter();
const route = useRoute();
const store = useStore();
const { userId: paramUserId } = route.params;

const checkPrefilledLogin = async (userId: any) => {
  const loading = await loadingController.create({ message: "Loading..." });
  await loading.present();
  try {
    const existingFirebaseUser = await AuthService.checkPhoneExists(null, userId, true);
    if (existingFirebaseUser && existingFirebaseUser.s == 200 && existingFirebaseUser.t) {
      await customTokenSignin(existingFirebaseUser.t);
    } else {
      store.commit('setLoadingUser', false);
      router.replace({ path: '/login', query: { redirectPath: '/update-roles' } });
    }
  } catch (e) {
    console.log(e);
  } finally {
    loading.dismiss();
  }
}
if (paramUserId) checkPrefilledLogin(paramUserId);

const goBack = () => {
  if (props.isPage) router.replace('/home');
  else closeModal();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonGrid), { fixed: "" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonToolbar), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButtons), { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButton), {
                        slot: "icon-only",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), { icon: _unref(arrowBack) }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonTitle), null, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("Update your information")
                    ])),
                    _: 1,
                    __: [2]
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonToolbar), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonSegment), {
                    mode: "ios",
                    modelValue: selectedSection.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedSection).value = $event)),
                    scrollable: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonSegmentButton), { value: "personal" }, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode(" Your personal information ")
                        ])),
                        _: 1,
                        __: [3]
                      }),
                      _createVNode(_unref(IonSegmentButton), { value: "school" }, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createTextVNode(" Your position(s) in the school ")
                        ])),
                        _: 1,
                        __: [4]
                      }),
                      _createVNode(_unref(IonSegmentButton), { value: "class" }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode(" Your role(s) in class(es) ")
                        ])),
                        _: 1,
                        __: [5]
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(UserProfileFormModal, { hideHeader: true })
          ], 512), [
            [_vShow, selectedSection.value == 'personal']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(RoleInSchoolSelectModal, { hideHeader: true })
          ], 512), [
            [_vShow, selectedSection.value == 'school']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(RolesInClassesModal, { hideHeader: true })
          ], 512), [
            [_vShow, selectedSection.value == 'class']
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})